<template>
  <b-card v-if="summary" class="mb-1">
    <b-row>
      <b-col cols="6" md="2" class="text-center">
        <b-badge variant="light-secondary" class="mb-50">Недель</b-badge>
        <h4 class="mb-0">{{ summary.weeks }}</h4>
      </b-col>
      <b-col cols="6" md="2" class="text-center">
        <b-badge variant="light-success" class="mb-50">Выручка</b-badge>
        <h4 class="mb-0">{{ formatRub(summary.revenue) }}</h4>
      </b-col>
      <b-col cols="6" md="2" class="text-center">
        <b-badge variant="light-warning" class="mb-50">Расходы</b-badge>
        <h4 class="mb-0">{{ formatRub(summary.expenses && summary.expenses.total) }}</h4>
        <small class="text-muted">
          Х: {{ formatRub(summary.expenses && summary.expenses.hosts) }} / А: {{ formatRub(summary.expenses && summary.expenses.authors) }}
        </small>
      </b-col>
      <b-col cols="6" md="2" class="text-center">
        <b-badge :variant="`light-${profitVariant(summary.profit)}`" class="mb-50">Прибыль</b-badge>
        <h4 class="mb-0" :class="`text-${profitVariant(summary.profit)}`">{{ formatRub(summary.profit) }}</h4>
      </b-col>
      <b-col cols="6" md="2" class="text-center">
        <b-badge variant="light-primary" class="mb-50">Маржа</b-badge>
        <h4 class="mb-0">{{ formatPercent(summary.margin) }}</h4>
      </b-col>
      <b-col cols="6" md="2" class="text-center">
        <b-badge variant="light-info" class="mb-50">Частных игр</b-badge>
        <h4 class="mb-0">{{ summary.private && summary.private.games_count != null ? summary.private.games_count : '—' }}</h4>
        <small class="text-muted">
          {{ formatRub(summary.private && summary.private.revenue) }}
          · {{ summary.private && summary.private.players_count != null ? summary.private.players_count : '—' }} игроков
        </small>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BRow, BCol, BBadge } from 'bootstrap-vue'
import { formatRub, formatPercent, profitVariant } from '@/views/finance/utils'

export default {
  components: { BCard, BRow, BCol, BBadge },
  props: {
    summary: { type: Object, default: null },
  },
  setup() {
    return { formatRub, formatPercent, profitVariant }
  },
}
</script>
